import { lazy } from 'react'
import BasicLayout from '@/components/layout/BasicLayout'
import type { RouteConfig } from '@/router/index'
import { TEST_MODULE_CHITIET_ROUTE_PATH } from '@/modules/test-module-chitiet/constants'

/** Trang clone của DEV TEST — chỗ tiếp tục code test chi tiết module. */
export const appendTestModuleChiTietRoutes = (routes: RouteConfig[]): void => {
  routes.push({
    path: TEST_MODULE_CHITIET_ROUTE_PATH,
    name: 'TestModuleChiTiet',
    exact: true,
    layout: BasicLayout,
    component: lazy(() => import('@/modules/test-module-chitiet/TestModuleChiTietPage')),
    title: 'TEST MODULE',
  })
}
